/**
 * Event handling composable for MsSplitButton
 * Handles all user interactions - giữ nguyên logic gốc 100%
 */
export function useSplitButtonEvents(props, emit) {
  // Primary button click handler
  // Giữ nguyên logic gốc - emit primaryClick event
  const handlePrimaryClick = (event) => {
    emit('primaryClick', event)
  }

  // Menu item click handler
  // Giữ nguyên logic từ setup function gốc
  const clickItem = (item) => {
    emit('menuClick', item)
  }

  return {
    handlePrimaryClick,
    clickItem
  }
}
